import { render, staticRenderFns } from "./video-button.vue?vue&type=template&id=360dce07&scoped=true"
import script from "./video-button.vue?vue&type=script&lang=js"
export * from "./video-button.vue?vue&type=script&lang=js"
import style0 from "./video-button.vue?vue&type=style&index=0&id=360dce07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360dce07",
  null
  
)

export default component.exports